import { render } from "./CheckSddXml.vue?vue&type=template&id=f5775d3c&scoped=true"
import script from "./CheckSddXml.vue?vue&type=script&lang=js"
export * from "./CheckSddXml.vue?vue&type=script&lang=js"

import "./CheckSddXml.vue?vue&type=style&index=0&id=f5775d3c&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5775d3c"]])

export default __exports__